/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveAssetSelfEmploymentRequest
 */
export interface SaveAssetSelfEmploymentRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetSelfEmploymentRequest
     */
    hasSelfEmploymentIncome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetSelfEmploymentRequest
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveAssetSelfEmploymentRequest
     */
    monthlyIncome: number | null;
}

/**
 * Check if a given object implements the SaveAssetSelfEmploymentRequest interface.
 */
export function instanceOfSaveAssetSelfEmploymentRequest(value: object): value is SaveAssetSelfEmploymentRequest {
    if (!('hasSelfEmploymentIncome' in value) || value['hasSelfEmploymentIncome'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('monthlyIncome' in value) || value['monthlyIncome'] === undefined) return false;
    return true;
}

export function SaveAssetSelfEmploymentRequestFromJSON(json: any): SaveAssetSelfEmploymentRequest {
    return SaveAssetSelfEmploymentRequestFromJSONTyped(json, false);
}

export function SaveAssetSelfEmploymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetSelfEmploymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hasSelfEmploymentIncome': json['hasSelfEmploymentIncome'],
        'description': json['description'],
        'monthlyIncome': json['monthlyIncome'],
    };
}

export function SaveAssetSelfEmploymentRequestToJSON(json: any): SaveAssetSelfEmploymentRequest {
    return SaveAssetSelfEmploymentRequestToJSONTyped(json, false);
}

export function SaveAssetSelfEmploymentRequestToJSONTyped(value?: SaveAssetSelfEmploymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasSelfEmploymentIncome': value['hasSelfEmploymentIncome'],
        'description': value['description'],
        'monthlyIncome': value['monthlyIncome'],
    };
}

